if (!customElements.get('whatsapp-order-button')) {
  customElements.define(
    'whatsapp-order-button',
    class WhatsappOrderButton extends HTMLElement {
      connectedCallback() {
        this.variant = null;
        this.link = this.querySelector('a');
        this.link?.addEventListener('click', this.openOrder.bind(this));

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribeVariantChange = subscribe(PUB_SUB_EVENTS.variantChange, this.handleVariantChange.bind(this));
        }
      }

      disconnectedCallback() {
        this.unsubscribeVariantChange?.();
      }

      // Hay un solo producto por página: el botón del hero y el del CTA final usan la misma variante elegida.
      handleVariantChange({ data: { variant } }) {
        this.variant = variant || null;
        this.updateLink(variant);
      }

      updateLink(variant) {
        if (!this.link) return;

        if (!variant) {
          this.link.setAttribute('aria-disabled', 'true');
          return;
        }

        this.link.removeAttribute('aria-disabled');

        const includeVariant = this.dataset.includeVariant === 'true';
        const variantTitle = variant.title && variant.title !== 'Default Title' ? variant.title : '';

        let message = this.dataset.messageTemplate.replace('{product}', this.dataset.productTitle);
        if (includeVariant && variantTitle) {
          message += ` (${variantTitle})`;
        }

        const phone = (this.dataset.phone || '').replace(/[^0-9]/g, '');
        const base = phone ? `https://wa.me/${phone}` : 'https://wa.me/';
        this.link.href = `${base}?text=${encodeURIComponent(message)}`;
      }

      // Abre la ventana de pedido (recoger o domicilio). Si no existe, el enlace directo a WhatsApp sigue funcionando.
      openOrder(event) {
        const pedido = document.getElementById('DeseoPedido');
        if (!pedido || typeof pedido.open !== 'function') return;

        event.preventDefault();
        if (this.link.getAttribute('aria-disabled') === 'true') return;

        const variant = this.variant;
        const variantTitle = variant ? variant.title : this.dataset.variantTitle;

        pedido.open({
          title: this.dataset.productTitle,
          variant: variantTitle && variantTitle !== 'Default Title' ? variantTitle : '',
          price: variant ? variant.price : Number(this.dataset.price || 0),
          url: this.dataset.productUrl + (variant ? `?variant=${variant.id}` : ''),
        });
      }
    }
  );
}
